import { ColorSettings } from "./types";

export const defaultColors: ColorSettings = {
  light: {
    primary: "#1d4ed8",
    primaryHover: "#1e40af",
    primaryText: "#ffffff",
    settingsButton: "#1d4ed8",
    settingsButtonHover: "#1e40af",
    settingsButtonText: "#ffffff",
    background: "#ffffff",
    text: "#111827",
    border: "#e5e7eb",
  },
  dark: {
    primary: "#3b82f6",
    primaryHover: "#2563eb",
    primaryText: "#ffffff",
    settingsButton: "#3b82f6",
    settingsButtonHover: "#2563eb",
    settingsButtonText: "#ffffff",
    background: "#111827",
    text: "#ffffff",
    border: "#374151",
  },
};
